import React, { useState, useEffect, useRef } from "react";
import { notification, Button, Card, Row, Input, Typography, Col, Modal, Upload, Spin, Rate } from "antd";
import { Map, TileLayer, Marker, Popup } from "react-leaflet"; // Using Map instead of MapContainer
import { PlusOutlined } from "@ant-design/icons";
// import Dropzone from "react-dropzone";
import { controller } from "../../controller";
import config from "../../config";
import DashboardLayout from "../../layout/dashboardLayout/DashboardLayout";
import "./style.css";

import back from "../../assets/img/AdobeStock_428089463-1-scaled 3.png";
import edit from "../../assets/icons/edit.png";
import add from "../../assets/icons/add-circle20.png";

const { Title, Text } = Typography;

const EditOffice = () => {
  const [office, setOffice] = useState({
    name: "",
    state: "",
    city: "",
    address: "",
    email: "",
    latitude: "",
    longitude: "",
    phone: "",
    zip_code: "",
    featured_images: [],
    delete_images: [],
    financing_provider_link: "",
  });
  // const [officedf, setOfficedf] = useState({
  //   name: "",
  //   state: "",
  //   city: "",
  //   address: "",
  //   email: "",
  //   latitude: "",
  //   longitude: "",
  //   phone: "",
  //   zip_code: "",
  //   featured_images: [],
  //   delete_images: [],
  // });
  const [logoFile, setLogoFile] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [previewImage, sePreviewImage] = useState("");
  const [editOfficeMode, setEditOfficeMode] = useState(false);
  const [editLocationMode, setEditLocationMode] = useState(false);
  const [editNameMode, setEditNameMode] = useState(false);
  const [errors, setErrors] = useState({
    name: "",
    state: "",
    city: "",
    address: "",
    email: "",
    latitude: "",
    longitude: "",
    phone: "",
    zip_code: "",
    featured_images: "",
  });
  const [locationValue, setLocationValue] = useState();
  const [fileList, setFileList] = useState([]);
  const [officeFileList, setOfficeFileList] = useState([]);
  const inputRef = useRef();
  // const uploadButton = (
  //   <div>
  //     <PlusOutlined />
  //     <div className="ant-upload-text">Upload</div>
  //   </div>
  // );

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleChangeFeaturedImage = ({ fileList }) => {
    setFileList(fileList);
  };

  const handleChangeOfficeImage = ({ fileList }) => {
    setOfficeFileList(fileList);
  };

  const handleCancel = () => {
    setPreviewVisible(false);
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewVisible(true);
    sePreviewImage(file.url || file.preview);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOffice({
      ...office,
      [name]: value,
    });
  };
  const handleDeleteImage = (e) => {
    if (office.delete_images) {
      setOffice({
        ...office,
        delete_images: [...office.delete_images, e.uid],
      });
    } else {
      setOffice({
        ...office,
        delete_images: [e.uid],
      });
    }
  };

  const getOfficeDetail = async () => {
    const response = await controller.getOfficeDetail(office);
    if (response.data) {
      if (response.data.featured_images.length !== 0) {
        const updatedData = {
          featured_images: response.data.featured_images.map((imageObj) => ({
            url: config.apiGateway.URL + `${imageObj.image}`,
            uid: imageObj.id,
            name: "",
            status: "done",
          })),
        };
        setFileList(updatedData.featured_images);
      }
      if (response.data.office_images.length !== 0) {
        const updatedData = {
          office_images: response.data.office_images.map((imageObj) => ({
            url: config.apiGateway.URL + `${imageObj.image}`,
            uid: imageObj.id,
            name: "",
            status: "done",
          })),
        };
        setOfficeFileList(updatedData.office_images);
      }
    }
  };
  const getOfficeProfile = async () => {
    try {
      const response = await controller.getOfficeProfile();
      if (response && response.data) {
        setLogoFile(response.data.logo);
        setOffice({
          ...office,
          ...response.data,
          latitude: response.data.latitude,
          longitude: response.data.longitude,
        });
      }
    } catch (error) {
      // Handle your error here
      console.error("Error fetching office profile:", error);
    }
  };

  const handleEditOffice = async (payload, alert) => {
    setErrors({
      name: "",
      state: "",
      city: "",
      address: "",
      email: "",
      latitude: "",
      longitude: "",
      phone: "",
      zip_code: "",
      featured_images: "",
    });

    try {
      const response = await controller.EditOfficeProfile({
        ...payload,
        id: office.id, // assuming the ID is necessary for the endpoint
      });

      if (response.status === 400) {
        setErrors(response.json); // assuming your API returns errors in a json object
        setOffice({ ...office, delete_images: [] }); // Reset delete images array
      } else {
        setOffice({ ...office, delete_images: [] }); // Reset delete images array
        if (alert) {
          notification.success({
            message: "Success",
            description: "Office information updated successfully",
            placement: "topRight",
          });
        }
      }
    } catch (error) {
      console.error("Error updating office info:", error);
      // You might want to show an error notification here
    }
  };

  const updateName = () => {
    const namePayload = { name: office.name };
    handleEditOffice(namePayload, true);
    setEditNameMode(false);
  };

  const updateContactInfo = () => {
    const contactInfo = {
      email: office.email,
      phone: office.phone,
      financing_provider_link: office.financing_provider_link,
    };
    handleEditOffice(contactInfo, true);
    setEditOfficeMode(false);
  };

  const updateLocationInfo = () => {
    const locationInfo = {
      city: office.city,
      state: office.state,
      address: office.address,
      zip_code: office.zip_code,
    };
    handleEditOffice(locationInfo, true);
    setEditLocationMode(false);
  };

  const getGoogleLocation = async (latitude, longitude, officeData, changeValue) => {
    const apiKey = "AIzaSyD656YHmwQkieoKwzJopN31fZmr9Vly7w0";
    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;
    try {
      const response = await fetch(apiUrl);
      const data = await response.json();
      const name = data.results[0].formatted_address;
      if (data.results.length > 0) {
        setOffice({
          ...officeData,
          longitude: `${longitude}`,
          latitude: `${latitude}`,
        });
        if (changeValue) {
          setLocationValue(name);
        }
      }
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  };

  useEffect(() => {
    getOfficeProfile();
    getOfficeDetail();
  }, []);

  useEffect(() => {
    if (locationValue) handleChangeLocation();
  }, [locationValue]);

  const handleChangeLocation = () => {
    if (window.google && window.google.maps && window.google.maps.places && window.google.maps.places.Autocomplete) {
      const autoCompleteOptions = {
        types: ["geocode"],
      };

      const autoComplete = new window.google.maps.places.Autocomplete(inputRef.current, autoCompleteOptions);

      autoComplete.addListener("place_changed", async () => {
        const place = autoComplete.getPlace();

        if (place && place.geometry && place.geometry.location) {
          const latitude = place.geometry.location.lat();
          const longitude = place.geometry.location.lng();
          const locationName = place.name;
          getGoogleLocation(latitude, longitude, office, false);

          setLocationValue(locationName);
        }
      });
    } else {
      console.error("Google Maps objects are not available.");
    }
  };

  const updateOfficeImage = async (e) => {
    setUploading(true);
    try {
      await handleEditOffice(false);
      const formData = new FormData();
      formData.append("office_images", e);

      const myHeaders = Object.assign(controller.authHeader());
      const req = new Request(config.apiGateway.URL + `/clinics/update-office-profile/${office.id}/`, {
        body: formData,
        method: "PATCH",
        headers: myHeaders,
      });
      const response = await fetch(req);
      setUploading(false);
      getOfficeDetail();
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  const updateFeaturedImage = async (e) => {
    setUploading(true);
    try {
      await handleEditOffice(false);
      const formData = new FormData();
      formData.append("featured_images", e);

      const myHeaders = Object.assign(controller.authHeader());
      const req = new Request(config.apiGateway.URL + `/clinics/update-office-profile/${office.id}/`, {
        body: formData,
        method: "PATCH",
        headers: myHeaders,
      });
      const response = await fetch(req);
      setUploading(false);
      getOfficeDetail();
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  const updateAvatar = async (e) => {
    setLogoFile(URL.createObjectURL(e));
    const formData = new FormData();
    formData.append("logo", e);
    try {
      setUploadingLogo(true);
      const myHeaders = Object.assign(controller.authHeader());
      const req = new Request(config.apiGateway.URL + `/clinics/update-office-profile/${office.id}/`, {
        body: formData,
        method: "PATCH",
        headers: myHeaders,
      });
      const response = await fetch(req);
      setUploadingLogo(false);
    } catch (error) {
      setUploadingLogo(false);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 14px",
    fontSize: "14px",
    border: "1px solid #d9d9d9",
    borderRadius: "4px",
    outline: "none",
    transition: "border-color 0.3s",
  };
  const renderUploadTile = (
    <div className="profile_upload_tile">
      <img src={add} alt="" />
      <div className="profile_upload_tile_text">Drag and drop or Browse your files</div>
    </div>
  );

  return (
    <DashboardLayout breadCrumb={false} logo={""} footerLogo={true}>
      <div className="profile_page_wrapper">
        <Title level={3} className="profile_page_title">Profile</Title>
        <Card className="profile_card" bodyStyle={{ padding: 0 }}>
          <div className="profile_banner">
            <img src={back} alt="" className="profile_banner_img" />
            <div className="profile_avatar_wrapper">
              <Upload
                showUploadList={false}
                beforeUpload={(e) => {
                  updateAvatar(e);
                  return false;
                }}
                className="profile_upload-btn"
                accept="image/*"
                disabled={uploadingLogo}
              >
                {uploadingLogo ? (
                  <div className="profile_avatar_spin">
                    <Spin />
                    <div>Uploading</div>
                  </div>
                ) : logoFile ? (
                  <img
                    src={logoFile}
                    alt="Logo"
                    className="profile_avatar_img"
                    onMouseEnter={(e) => {
                      e.target.style.opacity = 0.5;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.opacity = 1;
                    }}
                  />
                ) : (
                  <div className="profile_avatar_placeholder">
                    <PlusOutlined style={{ marginRight: 5 }} />
                    <span>Upload</span>
                  </div>
                )}
              </Upload>
            </div>
          </div>

          <div className="profile_header_row">
            <div className="profile_header_name">
              {editNameMode ? (
                <Input
                  value={office.name}
                  onChange={(e) => setOffice({ ...office, name: e.target.value })}
                  style={{ width: 260, height: 36 }}
                />
              ) : (
                <span className="profile_name_text">{office.name}</span>
              )}
              <Button
                type="text"
                icon={<img src={edit} alt="" />}
                onClick={editNameMode ? updateName : () => setEditNameMode(true)}
                style={{ color: "#979797" }}
              />
            </div>
            <div className="profile_header_rating">
              <span>
                <span style={{ fontSize: 16, fontWeight: 500 }}>4.7 </span>
                <span style={{ fontSize: 10, fontWeight: 500, color: "#979797" }}>/5</span>
              </span>
              <Rate disabled defaultValue={4.7} allowHalf className="custom-rate" />
            </div>
          </div>

          <Row gutter={[32, 32]} className="profile_content_row">
            <Col xs={24} lg={16}>
              <section className="profile_section">
                <div className="profile_section_header">
                  <Title level={4} style={{ margin: 0 }}>Office Information</Title>
                  <Button
                    type="text"
                    icon={<img src={edit} alt="" />}
                    onClick={editOfficeMode ? updateContactInfo : () => setEditOfficeMode(true)}
                    style={{ color: "#979797" }}
                  />
                </div>
                {editOfficeMode ? (
                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <Input name="phone" placeholder="Phone number" value={office.phone} onChange={handleChange} style={inputStyle} />
                    </Col>
                    <Col xs={24} md={12}>
                      <Input name="email" placeholder="Email" value={office.email} onChange={handleChange} style={inputStyle} />
                    </Col>
                    <Col xs={24}>
                      <Input
                        name="financing_provider_link"
                        placeholder="Financing Provider Link"
                        value={office.financing_provider_link}
                        onChange={handleChange}
                        style={inputStyle}
                      />
                    </Col>
                  </Row>
                ) : (
                  <div className="profile_info_grid">
                    <div>
                      <span className="profile_info_label">Phone: </span>
                      <span className="profile_info_value">{office.phone || "—"}</span>
                    </div>
                    <div>
                      <span className="profile_info_label">Email: </span>
                      <span className="profile_info_value">{office.email || "—"}</span>
                    </div>
                    <div className="profile_info_full">
                      <span className="profile_info_label">Financing Provider Link: </span>
                      <span className="profile_info_value">{office.financing_provider_link || "—"}</span>
                    </div>
                  </div>
                )}
              </section>

              <section className="profile_section">
                <label className="profile_section_label">Office</label>
                <div className="clearfix">
                  <Upload
                    listType="picture-card"
                    fileList={officeFileList}
                    onPreview={handlePreview}
                    onChange={handleChangeOfficeImage}
                    beforeUpload={(e) => {
                      updateOfficeImage(e);
                      return false;
                    }}
                    onRemove={handleDeleteImage}
                    className="custom-upload-list"
                    accept="image/*"
                    disabled={uploading}
                  >
                    {renderUploadTile}
                  </Upload>
                </div>
                {errors.office_images && <p className="red">{errors.office_images}</p>}
              </section>

              <section className="profile_section">
                <label className="profile_section_label">Featured</label>
                <div className="clearfix">
                  <Upload
                    fileList={fileList}
                    listType="picture-card"
                    onPreview={handlePreview}
                    onChange={handleChangeFeaturedImage}
                    beforeUpload={(e) => {
                      updateFeaturedImage(e);
                      return false;
                    }}
                    onRemove={handleDeleteImage}
                    className="profile_upload-btn"
                    accept="image/*"
                    disabled={uploading}
                  >
                    {renderUploadTile}
                  </Upload>
                </div>
                {errors.featured_images && <p className="red">{errors.featured_images}</p>}
              </section>
            </Col>

            <Col xs={24} lg={8}>
              <section className="profile_section">
                <div className="profile_section_header">
                  <Title level={4} style={{ margin: 0 }}>Location Information</Title>
                  <Button
                    type="text"
                    icon={<img src={edit} alt="" />}
                    onClick={editLocationMode ? updateLocationInfo : () => setEditLocationMode(true)}
                    style={{ color: "#979797" }}
                  />
                </div>

                <Map
                  center={[office.latitude || 0, office.longitude || 0]}
                  zoom={15}
                  scrollWheelZoom={true}
                  className="profile_map"
                >
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  />
                  {office.latitude && office.longitude && (
                    <Marker position={[office.latitude, office.longitude]}>
                      <Popup>Dental Clinic</Popup>
                    </Marker>
                  )}
                </Map>

                {editLocationMode ? (
                  <Row gutter={[12, 12]}>
                    <Col xs={24} md={12}>
                      <Input name="state" placeholder="State" value={office.state} onChange={handleChange} style={inputStyle} />
                    </Col>
                    <Col xs={24} md={12}>
                      <Input name="city" placeholder="City" value={office.city} onChange={handleChange} style={inputStyle} />
                    </Col>
                    <Col xs={24}>
                      <Input name="address" placeholder="Address" value={office.address} onChange={handleChange} style={inputStyle} />
                    </Col>
                    <Col xs={24}>
                      <Input name="zip_code" placeholder="Zip Code" value={office.zip_code} onChange={handleChange} style={inputStyle} />
                    </Col>
                  </Row>
                ) : (
                  <div className="profile_info_list">
                    <div><Text strong>State: </Text> <Text style={{ color: "#979797" }}>{office.state || "—"}</Text></div>
                    <div><Text strong>City: </Text> <Text style={{ color: "#979797" }}>{office.city || "—"}</Text></div>
                    <div><Text strong>Address: </Text> <Text style={{ color: "#979797" }}>{office.address || "—"}</Text></div>
                    <div><Text strong>Zip Code: </Text> <Text style={{ color: "#979797" }}>{office.zip_code || "—"}</Text></div>
                  </div>
                )}
              </section>
            </Col>
          </Row>
        </Card>

        <Modal visible={previewVisible} footer={null} onCancel={handleCancel}>
          <img alt="example" style={{ width: "100%" }} src={previewImage} />
        </Modal>
      </div>
    </DashboardLayout>
  );
};

export default EditOffice;
